<script setup>
import { defineProps, onMounted, ref } from 'vue'
import { useToast } from 'vue-toastification'

import TaxDeductionRequestDialog from '@/components/journal/parent/tax-deduction/TaxDeductionRequestDialog.vue'

import api from '@/api'
import { getErrors } from '@/errors'

defineProps(['user'])

const toast = useToast()

const isPending = ref(false)
const requests = ref(null)

const isDialogVisible = ref(false)

const fetchRequests = () => {
  isPending.value = true

  api.get('/legal/tax-deduction/report-requests/')
    .then(response => {
      requests.value = response.data
    }, error => {
      toast.error(getErrors(error).detail)
    })
    .then(() => {
      isPending.value = false
    })
}

onMounted(() => {
  fetchRequests()
})
</script>

<template>
  <div class="wrapper">
     <TaxDeductionRequestDialog
      v-if="isDialogVisible"
      @close="isDialogVisible = false"
      @success="fetchRequests"
      :user="user"
    />
    <div class="column">
      <div class="links">
        <router-link to="/journal/parent" class="back-link">
          <FontAwesomeIcon icon="chevron-left" size="lg" fixed-width />
          <div>Вернуться в Личный Кабинет</div>
        </router-link>
      </div>
      <h2 class="page-header">Справка для получения налогового вычета</h2>
      <div class="buttons">
        <button
          @click="isDialogVisible = true"
          class="button green no-margin"
        >
          <FontAwesomeIcon icon="plus" fixed-width />
          Создать заявку
        </button>
      </div>
      <BaseSpinner v-if="isPending" />
      <template v-else-if="requests && requests.length > 0">
        <div class="table-wrapper">
          <table class="table">
            <thead>
              <tr>
                <th>Дата создания</th>
                <th>Ребёнок</th>
                <th>Отчётный год</th>
                <th>Статус</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="request in requests" :key="request.id">
                <td>{{ $utils.formatDateTime(request.date_created) }}</td>
                <td>{{ request.student_first_name }}</td>
                <td>{{ request.year }}</td>
                <td :class="['request-status', request.status.toLowerCase()]">
                  <FontAwesomeIcon v-if="request.status === 'PENDING'" icon="clock" fixed-width />
                  <FontAwesomeIcon v-else-if="request.status === 'ACCEPTED'" icon="check" fixed-width />
                  <FontAwesomeIcon v-else-if="request.status === 'REJECTED'" icon="ban" fixed-width />
                  {{ request.status_display }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  position: relative;

  flex: 1;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.column {
  width: 1200px;

  flex: 1;

  display: flex;
  flex-direction: column;

  padding: 0 1em;
}

.table-wrapper {
  overflow: auto;
  min-height: 6em;
  margin: 1em -0.5em;
}

.request-status.pending {
  color: var(--teal);
}

.request-status.accepted {
  color: var(--green-darker);
}

.request-status.rejected {
  color: var(--red-darker);
}

.page-header {
  align-self: center;
}

.links {
  margin: 2em 0;
}

.back-link {
  display: flex;
  flex-direction: row;

  align-self: flex-start;

  font-weight: bold;
  color: var(--dark-gray);
}

@media screen and (max-width: 1200px) {
  .column {
    width: 100%;
  }
}
</style>
